<template>
    <div class="store">
        <div class="detail">
            <div class="block">{{ createdAt }}</div>
            <!--todo 店家名稱放這-->
            <div class="brand" v-if="$public.notNull(source)">{{ source }}</div>
            <span class="void" :class="{'read':isRead }" v-if="false">{{isRead?'已讀取':'未讀取'}}</span>
        </div>
        <div class="name" v-html="content"/>
        <div class="text" v-if="$public.notNull(contentBody)" v-html="contentBody"></div>
    </div>
</template>

<script>
    export default {
        name: "NoticeItem",
        props: ['content', 'createdAt', 'isRead', 'source', 'contentBody'],
        data() {
            return {}
        },
        created() {

        },
        mounted() {

        },
        methods: {}
    }
</script>

<style lang="less" scoped>
    .store {
        padding: 10px;
        .name {
            color: #6F5B62;
            font-size: 16px;
            font-weight: 400 !important;
            line-height: 1.2;
            margin-bottom: 2px;
        }
        .detail {
            margin-bottom: 2px;
            font-size: 12px;
            line-height: 22px;
            display: flex;
            flex-wrap: nowrap;
            width: 100%;
            align-items: center;
            color: #333;
            .brand{
                flex: 1;
                text-align: right;
                word-wrap:break-word;
                word-break: break-all;
            }
            .block{
                white-space:nowrap;
                &::before {
                    content: "\2022";
                    font-weight: bold;
                    display: inline-block;
                    width: 6px;
                    margin-right: 4px;
                    color: #333;
                }
            }
            .void {
                color: #fff;
                padding: 2px 7px;
                background: var(--color-red);
                border-radius: 20px;
                line-height: 1.25em;
                margin-left: 3px;
                &.read{
                    background: #A9A29B;
                }
            }
        }
        .text{
            font-size: 14px;
            line-height: 1.4em;
            margin-top: 6px;
            text-align: justify;
        }
    }
</style>